import {CANCEL, CLOSE} from "../../../_actions/group/groupReducer";

export const messageType = {
    delete: {
        title: "Удаление группы",
        content: "Вы дейтвительно хотите удалить группу?",
        buttons: {
            accept: "Удалить",
            cancel: "Назад",
        }
    },
    [CLOSE]: {
        title: "Завершение урока",
        content: "Не забудте отметить посещение.",
        buttons: {
            accept: "Завершить",
            cancel: "Назад",
        }
    },
    [CANCEL]: {
        title: "Отмена урока",
        content: "Вы действительно хотите отменить урок?",
        buttons: {
            accept: "Отменить урок",
            cancel: "Назад",
        }
    },
}